import TextBox from 'devextreme-react/text-box';
import {useContext} from 'react';
import {Field, Panel} from '../../../../layouts';
import {AR} from '../../../../types/enums';
import {formatShortDate} from '../../../../utils/date-utils';
import {formatMoney} from '../../../../utils/string-utils';
import {RetailOrderContext} from '../context/RetailOrderContext';


export default function CFICheckInformationPanel() {
	const { order, modifyOrder } = useContext(RetailOrderContext);

	return (
		<Panel header={'CFI Check Information'}
		>
			<Field label='CFI Payment #'>
				<TextBox inputAttr={{ 'data-testid': 'txt-cfi-invoice-number' }}
					readOnly={!order.details.activeARs.includes(AR.CfiToUploadCocInvoice)}
					value={order.details.cfiInvoiceNumber}
					onValueChanged={(e) => modifyOrder({ ...order.details, cfiInvoiceNumber: e.value })}
				/>
			</Field>
			<Field label='Check #'>
				{order.details.cfiCheckNumber}
			</Field>
			<Field label='Amount Paid'>
				{formatMoney(order.details.cfiAmountPaid)}
			</Field>
			<Field label='Date Paid'>
				{formatShortDate(order.details.cfiDatePaid)}
			</Field>
			<Field label='Approved COC Date'>
				{formatShortDate(order.details.approvedInvoiceDate)}
			</Field>
		</Panel>
	);
}
